import React from 'react';
import icon from '../../../assets/logo.svg';

export default function iconTab() {
  return <img src={icon} alt="TeamScrumIcon" />;
}
